// extracted by mini-css-extract-plugin
export default {"del":"VariantDelete_del__LHBvh"};